/**
 * Type de fonctionnalité patient
 */
export enum PatientTypeEnum {
	BILLING_CURRENT = 'billing-current',
	BILLING_PAST = 'billing-past',
	IDEL_CURRENT = 'idel-current',
	IDEL_PAST = 'idel-past',
	IDEL_PATIENT_LINK = 'idel-user-patient',
	IDEL_VALIDATOR_VALIDATION = 'idel-validator-validation',
	IDEL_VALIDATOR_TREATED = 'idel-validator-treated',
	PCR_PATIENT = 'pcr-patient',
	PROJECT = 'project'
}
